module.exports = __webpack_public_path__ + "static/media/autochilango-bumper_selected.0b5d2b1b.svg";